import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {HomeComponent} from './pages/home/home.component';
import {BaseComponent} from './pages/base/base.component';
import {InformationsComponent} from './pages/informations/informations.component';
import {AuthorizedGuard} from './guards/authorized.guard';
import {CodeGuard} from './guards/code.guard';
import {SickNoteComponent} from './pages/sick-note/sick-note.component';
import {ChatComponent} from './pages/chat/chat.component';
import {EntryModeResolverService} from './resolvers/entry-mode-resolver.service';
import {TermsAcceptedGuard} from './guards/terms_accepted.guard';
import {DocTypeGuard} from './guards/doc-type.guard';
import {FileExistsGuard} from './guards/file-exists.guard';
import {TermsComponent} from './pages/terms/terms.component';
import {DocTypeComponent} from './pages/doc-type/doc-type.component';
import {TermsResolverService} from './resolvers/terms-resolver.service';
import {ValidationComponent} from './pages/validation/validation.component';
import {SickNoteResolverService} from './resolvers/sick-note-resolver.service';

const routes: Routes = [
  {path: '', component: HomeComponent},
  {
    path: 's',
    component: BaseComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: {title: 'Confirme seus dados'}
      }, {
        path: 'validacao',
        component: ValidationComponent,
        data: {title: 'Acompanhe o status do seu atestado'},
        canActivate: [AuthorizedGuard],
      }, {
        path: 'termos',
        component: TermsComponent,
        data: {title: 'Resumo de termos e regras'},
        canActivate: [AuthorizedGuard, CodeGuard],
        resolve: {term: TermsResolverService}
      }, {
        path: 'termos/completo',
        component: TermsComponent,
        data: {title: 'Termos e Regras completas', type: 'complete'},
        canActivate: [AuthorizedGuard, CodeGuard],
        resolve: {term: TermsResolverService}
      }, {
        path: 'documento',
        component: DocTypeComponent,
        data: {title: 'Qual documento você vai cadastrar?'},
        canActivate: [AuthorizedGuard, CodeGuard, TermsAcceptedGuard],
      }, {
        path: '',
        component: ChatComponent,
        resolve: {settings: EntryModeResolverService},
        canActivate: [AuthorizedGuard, CodeGuard, TermsAcceptedGuard, DocTypeGuard]
      }, {
        path: 'data',
        component: SickNoteComponent,
        data: {title: 'Digite a data do atendimento'},
        canActivate: [AuthorizedGuard, CodeGuard, TermsAcceptedGuard, FileExistsGuard]
      }
    ]
  },
  {
    path: 'a',
    component: BaseComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/status/status.module').then(m => m.StatusModule),
        canActivate: [AuthorizedGuard]
      }
    ],
  },
  {
    path: 'info/:shortId',
    component: InformationsComponent,
    canActivate: [AuthorizedGuard],
    resolve: {resolved: SickNoteResolverService}
  },
  {path: '**', redirectTo: '/', pathMatch: 'full'}
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
